import { library, dom, config } from '@fortawesome/fontawesome-svg-core';

import {
  // authentication
  faSignIn, faSignOut,
  // notifications
  faBell as fasBell,
  // navigation
  faHouse,
  faBarsProgress as fasBarsProgress,
  faLink as fasLink,
  // alerts
  faExclamationTriangle as fasExclamationTriangle,
  // security
  faShieldHalved as fasShieldHalved,
  faLock as fasLock,
  // commands
  faCopy as fasCopy,
} from '@fortawesome/free-solid-svg-icons';

import {
  // notifications
  faBell as farBell,
  // support
  faQuestionCircle as farQuestionCircle,
} from '@fortawesome/free-regular-svg-icons';

config.autoAddCss = false;
config.keepOriginalSource = false;
config.autoReplaceSvg = true;
config.observeMutations = true;

library.add(
  // authentication
  faSignIn,
  faSignOut,
  // notifications
  fasBell,
  farBell,
  // navigation
  faHouse,
  fasBarsProgress,
  fasLink,
  // alerts
  fasExclamationTriangle,
  // security
  fasShieldHalved,
  fasLock,
  // commands
  fasCopy,
  // support
  farQuestionCircle,
);
dom.watch();
